// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photos[data-v-7cd6aa0e]{margin:0 -5px;flex-wrap:wrap}.photos__image[data-v-7cd6aa0e]{width:calc(20% - 10px);height:100px;margin:5px;background:transparent no-repeat 50%/cover}@media screen and (max-width:768px){.photos__image[data-v-7cd6aa0e]{width:calc(33.33% - 10px);height:150px}}@media screen and (max-width:500px){.photos__image[data-v-7cd6aa0e]{width:calc(50% - 10px);height:150px}}", ""]);
// Exports
module.exports = exports;
